import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { DataService } from '../event/data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-usersnetwork',
  templateUrl: './usersnetwork.component.html',
  styleUrls: ['./usersnetwork.component.css']
})

export class UsersnetworkComponent implements OnInit {

  constructor(private http: HttpClient, private dataservice: DataService, private route: ActivatedRoute) {
    var event_ids: string[];
    if (this.route.routeConfig.path=="SSA") { // "She succeeds Awards" => SSA
      event_ids = [
        "b677c43d-0151-4c6f-9f21-270d06b895a0", // event ID of SSA1
        "633b0a52-406d-4c20-a8da-284bd24154ba", // event ID of SSA2
        "f967d8a2-af01-429d-8fb2-659fe5e8e842", // event ID of SSA3
      ];
      this.passForAuthentication='SheSucceeds2026';
      this.eventName='die Veranstaltung "She Succeeds Award 2026"'
    } else { // Jahresversammlung
      event_ids = [
        "89ea17aa-1e71-4117-9c6a-742cab59edb2", // event ID of current "Jahresversammlung" in CRM
      ];
    }
    this.getRegisteredUsersfromD365(event_ids);
  }

  private users: Participants[] = [];
  private searchedData: Participants[] = [];
  public authenticated: boolean = false;
  protected passForAuthentication = 'VdU2026Nuernberg';
  private eventName = 'die Jahresversammlung';
  loader = true;
  private sortBy = [ "Name (A-Z)", "Name (Z-A)", "Organization (A-Z)", "Organization (Z-A)" ]

  ngOnInit() {
    this.EmailDialogue();
  }
  public searchText(val: any){
    val = val.toUpperCase()
    this.searchedData = this.users.filter(el => {
      return (
        el.name.toUpperCase().indexOf(val) !== -1 ||
        (el.organization && el.organization.toUpperCase().indexOf(val) !== -1) ||
        (el.territory && el.territory.toUpperCase().indexOf(val) !== -1) ||
        el.email.toUpperCase().indexOf(val) !== -1
      );
    });
  }
  public SortFn(val){
    if(val == "Name (A-Z)"){
      this.searchedData = this.searchedData.sort((a,b) => {
        var x = a.name.toLowerCase();
        var y = b.name.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
    else if (val == "Name (Z-A)"){
      this.searchedData = this.searchedData.sort((b,a) => {
        var x = a.name.toLowerCase();
        var y = b.name.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
    else if (val == "Organization (A-Z)"){
      this.searchedData = this.searchedData.sort((a,b) => {
        var x = a.organization.toLowerCase();
        var y = b.organization.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
    else if (val == "Organization (Z-A)"){
      this.searchedData = this.searchedData.sort((b,a) => {
        var x = a.organization.toLowerCase();
        var y = b.organization.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
  }
  private loadData(){
    this.searchedData = this.users;
    this.loader = false;
    this.authenticated = true;
    this.SortFn('Name (A-Z)');
    Swal.close();      
  }
  private async EmailDialogue() {
    const isEmailPresent = (emailToCheck: string): boolean => {
      return this.users.some(item => item.email === emailToCheck);
    }

    const { value: email } = await Swal.fire({
      title: 'Sign-In',
      input: 'email',
      text: 'Bitte geben Sie Ihre Emailadresse ein, mit der Sie sich für '+this.eventName+' angemeldet haben!',
      inputPlaceholder: 'Bitte geben Sie Ihre Emailadresse ein',
      confirmButtonText: 'Login',
      allowOutsideClick: false,
      allowEscapeKey: false,
      preConfirm: (value) => {
        // if (value && this.usersEmailFromApi.indexOf(value.toLowerCase())==-1 && isEmailPresent(value)) {
        if (value && !isEmailPresent(value)) {
          Swal.showValidationMessage(
            `Sorry, Sie sind nicht angemeldet!<br>
            (Bitte geben Sie Ihre Emailadresse ein, mit der Sie sich für `+this.eventName+` angemeldet haben!)`
          )
        } else if (value && isEmailPresent(value)) {
          this.PasswordDialogue();
        }
      }
    })
  }
  private async PasswordDialogue(){
    const { value: password } = await Swal.fire({
      title: 'Geben Sie das Passwort ein',
      input: 'password',
      inputPlaceholder: 'Geben Sie das Passwort ein',
      allowOutsideClick: false,
      allowEscapeKey: false,
      inputAttributes: {
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Sie müssen etwas schreiben!';
        } else if (value != this.passForAuthentication){
          return 'Falsches Passwort! Bitte versuche es erneut.';
        }
      }
    });
    if (password && password==this.passForAuthentication) {
      Swal.fire({
        title: 'Bitte warten Sie...',
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: async () => {
            Swal.showLoading(null);
            setTimeout( async () => {
              this.loadData();
            }, 1500);
        }
      });
    }
  }
  private async getRegisteredUsersfromD365(event_ids:string[]){
    var tmp_users:Participants[];
    for (const id of event_ids) {
      if (id.length==0) continue; // ignore empty event ids!
      const payload = { id: id }
      this.dataservice.getRegisteredUsers(payload).subscribe(async res => {
        let result = await JSON.parse(JSON.stringify(res));
        if(result && result.value && result.value.length>0){
          const users = result['value'];
          tmp_users = users.filter(el => { return el.email != null; });
          this.users = this.users.concat(Array.from( new Map(tmp_users.map(item => [item.email, item])).values() ));
        }
      });
    }
  }
}


export interface Participants {
  name: string;
  email: string;
  territory: string;
  organization: string;
  imgUrl: string;
  linkedIn: string;
  title: string;
}